/**
 * Feature flag constants organized by targeting type.
 * Each flag key must match the key defined in the AppConfig feature-flags JSON.
 *
 * ALLOWLIST_FLAGS: Enabled for specific aliases listed in the flag config.
 * PERCENTAGE_FLAGS: Enabled for a percentage of users via consistent hashing.
 * ORG_FLAGS: Enabled for users under a specific supervisor (requires supervisorChain context).
 * BRAVEHEARTS_FLAGS: Enabled for users in the Bravehearts program (checks DDB membership).
 */

export const ALLOWLIST_FLAGS = {
  VERBOSE_SUMMARIES: "verbose_summaries_allowlist",
  WHOS_WHO: "whos_who_allowlist",
};

export const PERCENTAGE_FLAGS = {
  VERBOSE_SUMMARIES: "verbose_summaries_percentage",
  AGENTIC_ASSISTANT: "agentic_assistant_percentage",
  WHOS_WHO: "whos_who_percentage",
  AGENDA: "agenda_percentage",
  ACTION_ITEMS: "action_items_percentage",
  INSIGHT_PUSH: "insight_push_percentage",
};

export const ORG_FLAGS = {
  VERBOSE_SUMMARIES: "verbose_summaries_org",
  BRAVEHEARTS: "bravehearts_org",
  WHOS_WHO: "whos_who_org",
  AGENDA: "agenda_org",
  ACTION_ITEMS: "action_items_org",
  INSIGHT_PUSH: "insight_push_org",
};

// Bravehearts flags — resolved by DDB membership, NOT by AppConfig rules. The backend checks
// whether the user's alias exists in the Bravehearts user table (see FeatureFlagLambda's
// "bravehearts" context) and returns that boolean directly; supervisorChain / org rules are not
// consulted. Being eligible turns on verbose summaries, the agentic assistant, and who's who.
export const BRAVEHEARTS_FLAGS = {
  IS_ELIGIBLE: "bravehearts_eligible",
};

// Country flags — uses AppConfig variant rules to block/allow based on user's country.
// The country is fetched from UserInfo DDB and passed to AppConfig as context.
// Blocked countries are configured in the flag's variant rules in CDK feature-flags/*.json.
export const COUNTRY_FLAGS = {
  AMAZON_MEETINGS_ASSISTANT_BLOCKED: "amazon_meetings_assistant_country_blocked",
};

// Group flags — checks BRASS BatchIsMemberOf at request time.
// groupType and groupIds are defined as attributes on the AppConfig flag, not in the frontend.
// Toggle on/off and change groups by editing the flag JSON in CDK — no frontend deploy needed.
export const GROUP_FLAGS = {
  AGENTIC_ASSISTANT: "agentic_assistant_posix",
  WHOS_WHO: "whos_who_posix",
};